// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ModalError-cls1___6357c2f58ac92b1e658{/*!*/}.ModalError-cls2__e864c17bc9f172490632{float:left;height:24px;color:#b60000;color:var(--red-100, #b60000)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ModalError-cls1___6357c2f58ac92b1e658",
	"cls2": "ModalError-cls2__e864c17bc9f172490632 ModalError-cls1___6357c2f58ac92b1e658"
};
export default ___CSS_LOADER_EXPORT___;
